module.exports = __webpack_public_path__ + "img/icon-chevron.51d8ccb4.svg";